import { AccountApi, AdjudicationApi, BiometricDataApi, Configuration, ExceptionsApi, ImagesApi, JanusApi, LicensingApi, ManagementApi, OperationsApi, SubjectsApi } from "neurotec-megamatcherid-management-client"
import {
    AdjudicationApi as AdAdjudicationApi,
    ManagementApi as AdManagementApi,
} from "neurotec-megamatcherid-management-client-adjudicator"

import configAxios, { getFullApiUrl } from "../../config/axios"
import { AuthenticationRole } from "../Authentication/types";

export type UnifiedAdjudicationApi = AdjudicationApi & AdAdjudicationApi;
export type UnifiedManagementApi = ManagementApi & AdManagementApi;

export const wrapApi = <T extends object>(api: T, role: AuthenticationRole): T => {
    return new Proxy(api, {
        get(target, prop: string) {
            if (role === AuthenticationRole.ROLE_ADMIN && !(prop in target)) {
                throw new Error(`Method ${prop} not allowed for admin`);
            }
            if (role === AuthenticationRole.ROLE_ADJUDICATOR && !(prop in target)) {
                throw new Error(`Method ${prop} not allowed for adjudicator`);
            }
            return (target as any)[prop];
        }
    });
}

export interface APIsState {
    JanusApi: JanusApi
    ManagementApi: UnifiedManagementApi
    SubjectsApi: SubjectsApi
    OperationsApi: OperationsApi
    ImagesApi: ImagesApi
    LicensingApi: LicensingApi
    ExceptionsApi: ExceptionsApi
    BiometricDataApi: BiometricDataApi
    AccountsApi: AccountApi
    AdjudicationApi: UnifiedAdjudicationApi
}

export const initAPIsState: APIsState = {
    JanusApi: new JanusApi(new Configuration({basePath: getFullApiUrl(), baseOptions: configAxios()})),
    ManagementApi: wrapApi(new ManagementApi(new Configuration({basePath: getFullApiUrl(), baseOptions: configAxios()})) as UnifiedManagementApi, AuthenticationRole.ROLE_ADMIN),
    SubjectsApi: new SubjectsApi(new Configuration({basePath: getFullApiUrl(), baseOptions: configAxios()})),
    OperationsApi: new OperationsApi(new Configuration({basePath: getFullApiUrl(), baseOptions: configAxios()})),
    ImagesApi: new ImagesApi(new Configuration({basePath: getFullApiUrl(), baseOptions: configAxios()})),
    LicensingApi: new LicensingApi(new Configuration({basePath: getFullApiUrl(), baseOptions: configAxios()})),
    ExceptionsApi: new ExceptionsApi(new Configuration({basePath: getFullApiUrl(), baseOptions: configAxios()})),
    BiometricDataApi: new BiometricDataApi(new Configuration({basePath: getFullApiUrl(), baseOptions: configAxios()})),
    AccountsApi: new AccountApi(new Configuration({basePath: getFullApiUrl(), baseOptions: configAxios()})),
    AdjudicationApi: wrapApi(new AdjudicationApi(new Configuration({basePath: getFullApiUrl(), baseOptions: configAxios()})) as UnifiedAdjudicationApi, AuthenticationRole.ROLE_ADMIN)
}